<template>
  <div class="search-filter" ref="filter">
    <template v-for="item in boxes">
      <!-- 校区筛选 -->
      <div
        class="filter-campus box"
        :key="item"
        v-if="item === 'campus'"
        @click="$emit('onCampus')"
      >
        <span class="van-ellipsis">{{ campusText }}</span>
        <van-icon
          class="icon"
          class-prefix="vxs-icon"
          name="system_choose"
          size="10"
          color="var(--g6)"
        />
      </div>

      <!-- 搜索框 -->
      <div class="box flexible search-container" :key="item" v-if="item === 'search'">
        <div class="search-inner" ref="search" :style="inputStyle">
          <van-icon
            class="arrow-icon"
            v-show="isSearchFocus"
            name="arrow-left"
            size="18"
            @click="searchBlur"
          />
          <div class="input-container" :class="{'is-focus' :isSearchFocus}">
            <van-icon
              class="search-icon"
              size="20"
              name="sousuo1"
              class-prefix="vxs-icon"
              color="var(--g5)"
              @click="onSearch"
            ></van-icon>
            <input
              class="search-input"
              v-model="keyword"
              :placeholder="placeholder"
              @focus="searchFocus"
              @keyup.enter="onSearch"
            />
            <van-icon
              @click="onCancel"
              class="clear-icon"
              class-prefix="vxs-icon"
              size="18"
              name="qingchu"
              v-show="isSearchFocus && keyword"
              color="var(--g6)"
            />
          </div>

          <van-button
            type="primary"
            class="search-button"
            v-show="isSearchFocus"
            size="small"
            @click="onSearch"
            >搜索</van-button
          >
        </div>
      </div>
      <div class="box flexible" :key="item" v-if="item === 'empty-center'"></div>

      <!-- 设置图标 -->
      <div class="box" :key="item" v-if="item === 'setting'">
        <div class="icon-button" @click="$emit('onSetting')">
          <van-icon class-prefix="vxs-icon" name="shezhi" size="24" color="var(--g8)"></van-icon>
        </div>
      </div>
      <!-- 添加图标 -->
      <div class="box" :key="item" v-if="item === 'add'">
        <div class="icon-button" @click="$emit('onAdd')">
          <van-icon class-prefix="vxs-icon" name="xinzeng" size="24" color="var(--g8)"></van-icon>
        </div>
      </div>

      <!-- 更多图标 -->
      <div class="box" :key="item" v-if="item === 'more'">
        <van-popover placement="bottom-end" v-model="showMore" trigger="click">
          <div class="search-filter-more-popover">
            <div
              class="more-item"
              v-for="li in more"
              :key="li.text"
              @click="onSelectMore(li)"
            >
              <van-icon
                class="icon"
                class-prefix="vxs-icon"
                size="24"
                color="var(--g8)"
                :name="li.icon"
              ></van-icon>
              <span class="more-item-text">{{ li.text }}</span>
            </div>
          </div>
          <template #reference>
            <div class="icon-button">
              <van-icon
                class-prefix="vxs-icon"
                name="gengduocaozuo"
                size="24"
                color="var(--g8)"
              ></van-icon>
            </div>
          </template>
        </van-popover>
      </div>

      <!-- 批量图标 -->
      <div class="box" :key="item" v-if="item === 'batch'">
        <div class="icon-button" @click="$emit('onBatch')">
          <van-icon
            class-prefix="vxs-icon"
            name="piliangxuanze"
            size="24"
            color="var(--g8)"
          ></van-icon>
        </div>
      </div>

      <!-- 过滤图标 -->
      <div class="box" :key="item" v-if="item === 'filter'">
        <div class="icon-button" @click="$emit('onFilter')">
          <van-icon
            class-prefix="vxs-icon"
            name="shaixuan1"
            size="24"
            :color="hasFilter ? 'var(--c1)' : 'var(--g8)'"
          ></van-icon>
        </div>
      </div>

      <!-- 导出图标 -->
      <div class="box" :key="item" v-if="item === 'export'">
        <div class="icon-button" @click="$emit('onExport')">
          <van-icon class-prefix="vxs-icon" name="shujudaochu" size="24" color="var(--g8)"></van-icon>
        </div>
      </div>

      <!-- 自定义图标 -->
      <div class="box" :key="item" v-if="item.startsWith('#')">
        <div class="icon-button" @click="$emit('onIcon', item)">
          <van-icon
            class-prefix="vxs-icon"
            :name="item.slice(1)"
            size="24"
            color="var(--g8)"
          ></van-icon>
        </div>
      </div>

      <!-- 时间筛选 -->
      <div
        class="filter-date box"
        :key="item"
        v-if="item === 'date-range'"
        @click="$emit('onDateRange')"
      >
        {{ startStr }} 至 {{ endStr }}
        <van-icon
          class="xiala"
          class-prefix="vxs-icon"
          name="system_choose"
          size="10"
          color="var(--g6)"
        />
      </div>

      <!-- 更多筛选 -->
      <div
        class="box filter-more"
        :class="{ 'has-filter': hasFilter }"
        :key="item"
        v-if="item === 'filter-more'"
        @click="$emit('onFilterMore')"
      >
        更多筛选
        <van-icon
          class="xiala"
          class-prefix="vxs-icon"
          name="filter-fill"
          size="10"
          :color="hasFilter ? 'var(--c1)' : 'var(--g8)'"
        />
      </div>

      <!-- 插槽 -->
      <slot v-if="item === 'slot'"></slot>

      <!-- 伸缩 -->
      <div class="flexible box" :key="item" v-if="item === '_split'"></div>
    </template>

    <slot v-if="boxes.length === 0"></slot>
  </div>
</template>

<script>
export default {
  name: 'search-filter-new',
  props: {
    /**
     * item不要重复
     *
     * 常规:
     * campus: 校区
     * search: 搜索框
     * date-range: 时间筛选
     *
     * 内置按钮类:
     * add: 添加按钮
     * more: 更多操作下拉按钮
     * batch: 批量操作按钮
     * filter: 筛选按钮
     * filter-more: 筛选更多(文字)
     * export: 导出按钮
     *
     *
     * 特殊:
     * #iconName: 自定义icon按钮,以#开头,事件: onIcon
     * _split: 左右分隔,极特殊情况用
     * slot: 插槽
     */
    items: {
      type: Array,
      default: () => [],
    },

    // 传入选中的校区，供计算属性使用，以展示选中的校区文案
    campus: null,

    // 更多操作的action
    more: {
      type: Array,
      default: () => [],
    },

    start: {
      type: String,
      default: '开始时间',
    },
    end: {
      type: String,
      default: '结束时间',
    },
    // 搜索框占位文本
    placeholder: {
      type: String,
      default: '请输入',
    },
    hasFilter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 是否展示搜索框
      isSearchFocus: false,
      inputStyle: {},
      filterStyle: {},
      keyword: '',
      showMore: false,
      params: {},
    };
  },
  mounted() {
    const style = getComputedStyle(this.$refs.filter);
    this.filterStyle = {
      width: parseInt(style.width),
      paddingLeft: parseInt(style.paddingLeft),
      paddingRight: parseInt(style.paddingRight),
    };
  },
  computed: {
    boxes() {
      return Array.from(new Set(this.items));
    },
    campusText: function () {
      if (Array.isArray(this.campus)) {
        if (this.campus.length == 0) {
          return '全部校区';
        } else if (this.campus.length == 1) {
          return this.campus[0].name;
        } else {
          return `${this.campus.length}个校区`;
        }
      } else if (typeof this.campus == 'object') {
        return this.campus.name;
      } else if (typeof this.campus == 'string') {
        return this.campus;
      } else {
        return '请传入选中校区';
      }
    },
    startStr: function () {
      return this.start && this.start.replace(/\./g, '-');
    },
    endStr: function () {
      return this.end && this.end.replace(/\./g, '-');
    },
  },
  provide() {
    const that = this;
    return {
      useQuery(key, val) {
        that.params[key] = val;
      },
      useChange() {
        that.$emit('change', JSON.parse(JSON.stringify(that.params)));
      },
    };
  },
  methods: {
    searchFocus() {
      if (!this.isSearchFocus) {
        this.isSearchFocus = true;
        const input = this.$refs.search[0];
        const { left } = app.dom.getPosition(input, this.$refs.filter);
        const { width } = input.getBoundingClientRect();
        this.inputStyle = {
          left: -(left - this.filterStyle.paddingLeft) + 'px',
          right: -(this.filterStyle.width - left - width - this.filterStyle.paddingRight) + 'px',
        };
      }
    },
    searchBlur() {
      this.isSearchFocus = false;
      this.inputStyle = {};
    },
    onSearch() {
      this.$emit('onSearch', this.keyword.trim());
    },
    onCancel() {
      this.keyword = '';
      this.$emit('onSearch', this.keyword.trim());
    },
    onSelectMore(action) {
      this.showMore = false;
      this.$emit('onMore', action);
    },
  },
};
</script>

<style lang="scss" scoped>
.search-filter {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--white);
  padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
  width: 100%;
  z-index: 12;
  .box {
    flex: 0 0 auto;
    &:last-child {
      .icon-button {
        margin-right: 0 !important;
      }
      &.search-container {
        margin-right: 0 !important;
      }
    }
    &.flexible {
      flex: 1 1 auto;
    }
    &.filter-campus {
      margin-right: calc(var(--gap) * 12);
      overflow: hidden;
      font-size: var(--fs-lg);
      line-height: var(--lh-lg);
      font-weight: var(--bold);
      max-width: calc(var(--gap) * 105);
      display: flex;
      justify-content: center;
      .icon {
        margin-left: 5px;
      }
    }
    &.search-container {
      margin-right: calc(var(--gap) * 16);
      height: 30px;
      position: relative;
      .search-inner {
        transition: all 0.2s ease-out;
        position: absolute;
        left: 0;
        right: 0;
        height: 100%;
        display: flex;
        align-items: center;
        background: var(--white);
        .input-container {
          flex: 1 1 auto;
          position: relative;
          width: 100%;
          height: 100%;
          &.is-focus {
            .search-input {
              padding-right: 30px;
            }
          }
          .search-input {
            outline: none;
            -webkit-appearance: none; 
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            border-radius: 4px;
            background: var(--g1);
            padding-left: calc(var(--gap) * 12);
            padding-left: 28px;
            padding-right: 12px;
            border: 0.5px solid var(--g3);
          }
          .clear-icon {
            position: absolute;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            right: 0;
            top: 0;
          }
          .search-icon {
            position: absolute;
            width: 28px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            left: 0;
            top: 0;
          }
        }
        .search-button {
          min-width: 50px;
          padding: 0;
          margin-left: 8px;
          height: 30px;
          border-radius: 4px;
        }
        .arrow-icon {
          width: 20px;
          height: 30px;
          flex: 0 0 auto;
          display: flex;
          align-items: center;
          transform: translate(-6px, 0);
        }
      }
    }

    &.filter-date {
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      color: var(--g8);
    }

    &.filter-more {
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      color: var(--g8);
      &.has-filter {
        color: var(--c1);
      }
    }
    .icon-button {
      background: var(--g1);
      border-radius: 50%;
      width: 32px;
      height: 32px;
      margin-right: calc(var(--gap) * 12);
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>


<style lang="scss">
.search-filter-more-popover {
  padding: 0 calc(var(--gap) * 16);
  .more-item {
    position: relative;
    display: flex;
    align-items: center;
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--g8);
    height: calc(var(--gap) * 42);
    .icon {
      font-weight: var(--bold);
    }
    .more-item-text {
      margin-left: calc(var(--gap) * 8);
    }
    &:not(:last-child)::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 1px;
      transform: scaleY(0.5);
      z-index: 10;
      background-color: var(--g3);
    }
  }
}
.search-filter {
  .filter-item .van-dropdown-menu__title::after {
    border-color: transparent transparent var(--g7) var(--g7);
  }
  .filter-item.has-filter .van-dropdown-menu__title::after,
  .filter-item.has-filter.has-down-icon::after {
    border-color: transparent transparent var(--c1) var(--c1);
  }
  .filter-item.has-filter,
  .shortcut-item.has-filter,
  .filter-item.has-filter .van-dropdown-menu__title {
    color: var(--c1);
  }
  .filter-item .van-dropdown-menu__title {
    color: var(--g7);
  }
  .shortcut-item {
    display: flex;
    flex: 1;
    color: var(--g7);
    align-items: center;
    justify-content: center;
    &.has-down-icon {
      display: flex;
      align-items: center;
      &::after {
        margin-left: calc(var(--gap) * 8);
        height: 0;
        border: 3px solid;
        border-color: transparent transparent var(--g7) var(--g7);
        transform: rotate(-45deg);
        transform-origin: left bottom;

        opacity: 0.8;
        content: '';
      }
    }
    &.justify-right {
      justify-content: flex-end;
    }
    &.justify-left {
      justify-content: flex-start;
    }
    &.flexible {
      flex: 1 0 auto;
    }
  }
  .van-dropdown-item--down {
    margin-top: calc(var(--gap) * 12);
    .van-popup--top {
      &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        height: 1px;
        transform: scaleY(0.5);
        z-index: 10;
        background-color: var(--g3);
      }
    }
  }
  &.van-hairline--bottom {
    &::after {
      z-index: 12;
    }
  }
}
</style>